import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-response-status-badge',
  templateUrl: './response-status-badge.component.html',
  styleUrls: ['./response-status-badge.component.scss'],
})
export class ResponseStatusBadgeComponent {
  @Input() closed = false;
  @Output() openOrCloseProject = new EventEmitter<boolean>();

  dropdownOpen = false;

  toggle(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  select(shouldClose: boolean): void {
    if (shouldClose !== this.closed) {
      this.openOrCloseProject.emit(shouldClose);
    }
    this.dropdownOpen = false;
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }
}
